const STORAGE_KEY = (scope: string) => `mixlr:accesscode:${scope}`;

export const getStoredAccesscode = (
  scope: string | null | undefined
): string | null => {
  if (!scope) return null;
  try {
    return window.localStorage.getItem(STORAGE_KEY(scope));
  } catch {
    return null;
  }
};

export const setStoredAccesscode = (scope: string, value: string): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY(scope), value);
  } catch {
    /* noop */
  }
};

export const clearStoredAccesscode = (scope: string): void => {
  try {
    window.localStorage.removeItem(STORAGE_KEY(scope));
  } catch {
    /* noop */
  }
};

export const eventScopeKey = (eventId: string | number): string =>
  `event:${eventId}`;
